import "./App.css";

function App() {
  return (
    <div className="main">
      <div className="intro">
        <div className="hath">
          <h1>Hello!<span class="wave">👋</span></h1>
        </div>
        <h1>
          I'm <b>Tarun Dhiman</b>, a Web Development and Design <br />
          enthusiast focused on creating beautifull web products
          <br /> through ingenious innovation.
        </h1>
        <h3>
          Get in touch -{" "}
          <a className="link" href="mailto:tarundhiman1309@gmail.com">
            tarundhiman1309@gmail.com
          </a>
        </h3>
      </div>
      <div className="background">
        <div className="BGtitle">
          <h4>BACKGROUND</h4>
        </div>
        <div className="BGinfo">
          <p>
            I am a Engineering graduate from{" "}
            <b>
              <a className="link" href="https://www.cuchd.in/">
                Chandigarh University
              </a>
            </b>
            , Mohali, Punjab, India.
            <br />
            My work is focused on developing web based products like websites
            using my
            <br /> skills related to web design and development.
          </p>
          <p>
            My goal is to build a website with the best design and functionality
            as it is rightly said -<br /> "Getting a quality website is not an
            expense but rather an investment."
          </p>
          <p>
            <b>When I'm not in front of a computer screen</b>, I'm probably
            playing football, drawing or watching movies.
          </p>
        </div>
      </div>
      <div className="skills">
        <div className="skillheading">
          <h4>SKILLS</h4>
        </div>
        <div className="skillinfo">
          <div className="skillz">
            <div className="lang">
              <b>LANGUAGES</b>
            </div>
            <ul>
              <li>C++</li>
              <li>Javascript</li>
              <li>Python</li>
              <li>HTML/CSS</li>
              <li>SQL</li>
            </ul>
          </div>
          <div className="skillz">
            <div className="frame">
              <b>FRAMEWORK/TOOLS</b>
            </div>
            <ul>
              <li>React.js</li>
              <li>gRPC</li>
              <li>GIT</li>
              <li>JIRA</li>
              <li>QT-Creator</li>
            </ul>
          </div>
          <div className="skillz">
            <div className="frame">
              <b>DATABASES</b>
            </div>
            <ul>
              <li>pSQL</li>
            </ul>
          </div>
          <div className="skillz">
            <div className="frame">
              <b>MISCELLANEOUS</b>
            </div>
            <ul>
              <li>DSA</li>
              <li>OOPS concept</li>
              <li>Netlify</li>
              <li>Microsoft Office</li>
            </ul>
          </div>
        </div>
      </div>
      <div className="experience">
        <div className="expheading">
          <h4>EXPERIENCE</h4>
        </div>
        <div className="expinfo">
          <div className="postdate">
            <div className="post">
              <b>
                <a className="link" href="https://utradesolutions.com/">
                  uTrade Solutions Pvt Ltd
                </a>
              </b>
              <br /> Software Enginneer Intern
            </div>
            <div className="date">June 2021 - Feb 2022</div>
          </div>
          <div className="detail">
            <ul>
              <li>
                Worked on QT Creator tool to provide a high level overview as
                well as data lineage for the data assets
              </li>
              <li>
                Added a new widget as per client request in the current HFT tool
                of the company.
              </li>
              <li>
                Added a data pipeline implementing batch‑queries which reduced
                the processing time of the data by 50%.
              </li>
              <li>
                Implemented gRPC replacing the old pipeline in the data
                instances of retail product
              </li>
              <li>
                Worked upon script files in back‑end for adding new fields and
                records in the database.
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="projets">
        <div className="projheading">
          <h4>PROJECTS</h4>
        </div>
        <div className="projinfo">
          <div className="projbox">
            <div className="projname">
              <b>Wallpaper-App </b>
              <a className="link" href="https://waller.netlify.app/">
                <i class="fa-solid fa-arrow-up-right-from-square"></i>
              </a>
            </div>
            <div className="description">
              <ul>
                <li>
                  A front‑end based wallpaper app with a search‑bar where users
                  get to view the image with an option to download it.
                </li>
              </ul>
            </div>
            <div className="tech">
              <div className="stack">React</div>
              <div className="stack">Javascript</div>
              <div className="stack">Html/CSS</div>
              <div className="stack">Pexels API</div>
            </div>
          </div>
          <div className="projbox">
            <div className="projname">
              <b>Amigo </b>
              <a className="link" href="https://aamigo.netlify.app/">
              <i class="fa-solid fa-arrow-up-right-from-square"></i>
              </a>
            </div>
            <div className="description">
              <ul>
                <li>
                  A dynamic front‑end project designed with the purpose of
                  helping those who are in need of food, shelter and clothes
                  during the pandemic.
                </li>
              </ul>
            </div>
            <div className="tech">
              <div className="stack">React</div>
              <div className="stack">Javascript</div>
              <div className="stack">Html/CSS</div>
            </div>
          </div>
          <div className="projbox">
            <div className="projname">
              <b>Employee Store </b>
            </div>
            <div className="description">
              <ul>
                <li>
                  A desktop application which stores the details of users using
                  a form layout to fill in the details
                </li>
                <li>Details are stored in the SQLite Database</li>
                <li>
                  Provides a table‑view to show the details of users by fetching
                  from the database.
                </li>
              </ul>
            </div>
            <div className="tech">
              <div className="stack">C++</div>
              <div className="stack">OOPS</div>
              <div className="stack">SQLite</div>
              <div className="stack">QT Creator</div>
            </div>
          </div>
        </div>
      </div>
      <div className="socials">
        <div className="socialinfo">
          <div className="socialbox">
            <a className="Slink" href="mailto:tarundhiman1309@gmail.com">
              Email
            </a>
          </div>
          <div className="socialbox">
            <a
              className="Slink"
              href="https://www.linkedin.com/in/tarun13dhiman/"
            >
              Linkedin
            </a>
          </div>
          <div className="socialbox">
            <a className="Slink" href="https://github.com/tarun2000">
              Github
            </a>
          </div>
          <div className="socialbox">
            <a className="Slink" href="https://twitter.com/tarun_dhimann08">
              Twitter
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;
